import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useEffect, useMemo } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { TabMenu } from 'ud-ui/components/tab-menu';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import Profile from './tabs/profile/profile';
import SocialNet from './tabs/social-net/social-net';
import Subscription from './tabs/subscription/subscription';

const SettingsPage = () => {
  const { setHeaderContent } = useMainLayout();
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = useMemo(() => {
    switch (true) {
      case location.pathname.includes('/social-net'):
        return 1;
      case location.pathname.includes('/subscription'):
        return 2;
      default:
        return 0;
    }
  }, [location.pathname]);

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Настройки</UDHeaderTitle>);

    return () => {
      setHeaderContent(null);
    };
  }, [setHeaderContent]);

  const changeTab = (tab: number) => {
    switch (tab) {
      case 1:
        navigate(Pages.SETTINGS.SOCIAL_NET);
        break;
      case 2:
        navigate(Pages.SETTINGS.SUBSCRIPTION);
        break;
      default:
        navigate(Pages.SETTINGS.INDEX);
    }
  };

  return (
    <>
      <div className="w-full px-6 py-6">
        <UDText type="headline" className="mr-10">
          Информация об организаторе
        </UDText>
      </div>
      <div>
        <TabMenu
          tabs={[
            { name: 'Профиль', active: true },
            { name: 'Ссылки', active: true },
            { name: 'Подписка', active: true },
          ]}
          activeTab={activeTab}
          onChange={changeTab}
        />
      </div>
      <div className="w-full px-6 py-6">
        <Routes>
          <Route path="/" element={<Profile />} />
          <Route path="/social-net" element={<SocialNet />} />
          <Route path="/subscription" element={<Subscription />} />
        </Routes>
      </div>
    </>
  );
};

export default SettingsPage;
